"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

const useClickAnyWhere = handler => {
  (0, _react.useEffect)(() => {
    const callback = event => handler(event);

    document.addEventListener('click', callback);
    return () => document.removeEventListener('click', callback);
  }, [handler]);
};

var _default = useClickAnyWhere;
exports.default = _default;
module.exports = exports.default;